import { useMutation, useQueryClient } from '@tanstack/react-query';

import { CreateQuizEventAdapter } from '~analytics/adapters/CreateQuizEventAdapter';
import { workspaceKeys } from '~teacher/hook/workspaces/workspaceQueryKeyFactory';

import { extractSocNumber } from '../../../api/utils';
import { importWorkspaceQuizBySoc } from '../../../api/workspaces/quiz';

export function useImportQuizToWorkspaceBySocMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: importWorkspaceQuizBySoc,

    onSuccess: (_data, { workspaceId, socNumber }) => {
      new CreateQuizEventAdapter({
        creation_method: 'code',
        source_soc_number: extractSocNumber(socNumber),
        destination_workspace_id: workspaceId,
      }).sendAnalytics();
    },

    onSettled: async (_data, _error, { workspaceId }) => {
      return Promise.all([
        queryClient.invalidateQueries(workspaceKeys.allQuizzes(workspaceId)),
        queryClient.invalidateQueries(workspaceKeys.list()),
      ]);
    },
  });
}
